/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { createMsalConfig } from './msalConfig'
import { getEnvironment } from './actions'
import { Logger, LoggerTypes } from './utils'
import { getEnvVarsFromStorage, setEnvVarsToStorage } from './storage/storage'
import App from './App'
import { SplashLoadingForm } from './components/forms/SplashLoadingForm'

const Authentication = () => {
  const env_vars = getEnvVarsFromStorage()
  const msalConfig = createMsalConfig(env_vars.AZURE_CLIENT_ID, env_vars.AZURE_AUTHORITY)
  const msalInstance = new PublicClientApplication(msalConfig)
  Logger.trace(LoggerTypes.INIT, 'Authentication with MSAL v2.0 - Initialization', {
    localStorage,
    env_vars,
    msalConfig,
    msalInstance
  })

  // msalInstance.addEventCallback((event) => {
  //   // This will be run every time an event is emitted after registering this callback
  //   if (event.eventType === EventType.LOGIN_SUCCESS) {
  //     Logger.trace(LoggerTypes.CONTROLLER, 'SignedIn.useEffect().LOGIN_SUCCESS', { msalInstance, event })
  //     msalInstance.setActiveAccount(event.payload.account)
  //   }
  // })

  // const _allAccount = msalInstance.getActiveAccount() || []
  // if (_allAccount && _allAccount.length > 0) {
  //   const _account = _allAccount[0] || null
  //   Logger.trace(LoggerTypes.INIT, 'Account => ', { account: _account })
  //   msalInstance.setActiveAccount(_account)
  // }

  // msalInstance.addEventCallback((event) => {
  //   if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
  //     const account = event.payload.account
  //     const accessToken = event.payload.accessToken
  //     Logger.trace(LoggerTypes.INIT, 'credentials => ', { accessToken, account })
  //     msalInstance.setActiveAccount(account)
  //   }
  // })

  return (
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  )
}

const SplashScreen = () => {
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (isLoading) {
      dispatch(getEnvironment())
        .then((res) => {
          Logger.trace(LoggerTypes.CONTROLLER, 'SplashScreen.useEffect().dispatch(getEnvironment()).then()', { res })

          // Store the env_vars into the localStorage as JSON
          setEnvVarsToStorage(res.data)
          Logger.trace(LoggerTypes.CONTROLLER, 'Environment Variables', {
            env: res.data
          })
          setIsLoading(false)
        })
        .catch((res) => {
          Logger.trace(LoggerTypes.CONTROLLER, 'SplashScreen.useEffect().dispatch(getEnvironment()).catch()', { res })
        })
    }
  }, [])

  return isLoading ? <SplashLoadingForm /> : <Authentication />
}

export default SplashScreen
